// Web Push subscription helper.
import client from "./api";

const VAPID_PUBLIC = process.env.REACT_APP_VAPID_PUBLIC_KEY;
const STORAGE_KEY = "meyecam.push.endpoint";

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window &&
    !!VAPID_PUBLIC
  );
}

function urlBase64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

async function ensureRegistration() {
  // Register once; reuse existing registration if present.
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
}

export async function getNotificationPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function subscribePush({ albumSlug, uploaderName }) {
  if (!pushSupported()) throw new Error("Push notifications not supported in this browser");
  if (!uploaderName?.trim()) throw new Error("Set your name first");

  const reg = await ensureRegistration();
  let permission = Notification.permission;
  if (permission === "default") {
    permission = await Notification.requestPermission();
  }
  if (permission !== "granted") {
    throw new Error("Notifications were blocked");
  }

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
    });
  }
  const payload = sub.toJSON();
  await client.post("/push/subscribe", {
    album_slug: albumSlug,
    uploader_name: uploaderName.trim(),
    subscription: payload,
  });
  localStorage.setItem(STORAGE_KEY, payload.endpoint);
  return true;
}

export async function unsubscribePush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) {
      await client.post("/push/unsubscribe", { endpoint: sub.endpoint });
      await sub.unsubscribe();
    }
  } catch (_) {}
  localStorage.removeItem(STORAGE_KEY);
}

export function isCurrentlySubscribed() {
  return !!localStorage.getItem(STORAGE_KEY);
}
